import React from "react";
import { Link } from "react-router-dom";
import { Clock, Play } from "lucide-react";
import { fileUrl } from "../api";

const PlayBadge = ({ small }) => (
  <span
    className={`absolute inset-0 flex items-center justify-center pointer-events-none`}
  >
    <span
      className={`flex items-center justify-center rounded-full bg-black/55 text-white ${
        small ? "w-8 h-8" : "w-12 h-12"
      }`}
    >
      <Play size={small ? 14 : 20} className="fill-white ml-0.5" />
    </span>
  </span>
);

const ArticleCard = ({ article, variant = "default" }) => {
  const isVideo = !!article.videoUrl;

  if (variant === "horizontal") {
    return (
      <Link to={`/articolo/${article.slug}`} className="group flex gap-4 items-start">
        <div className="card-img-wrap relative overflow-hidden rounded-sm flex-shrink-0 w-24 h-20">
          <img
            src={fileUrl(article.image)}
            alt={article.title}
            className="card-img-zoom w-full h-full object-cover"
          />
          {isVideo && <PlayBadge small />}
        </div>
        <div>
          <span className="text-[11px] uppercase tracking-wide text-sq-orange font-semibold">
            {article.category}
          </span>
          <h4 className="font-serif-display text-[15px] leading-snug text-sq-navy article-title-hover mt-1">
            {article.title}
          </h4>
          <span className="text-xs text-gray-400 mt-1 block">{article.date}</span>
        </div>
      </Link>
    );
  }

  return (
    <article className="group bg-white border border-sq rounded-sm overflow-hidden hover:shadow-lg transition-shadow duration-300">
      <Link to={`/articolo/${article.slug}`} className="card-img-wrap relative block overflow-hidden">
        <img
          src={fileUrl(article.image)}
          alt={article.title}
          className="card-img-zoom w-full h-52 object-cover"
        />
        {isVideo && <PlayBadge />}
        {isVideo && (
          <span className="absolute top-3 left-3 bg-sq-orange text-white text-[10px] uppercase tracking-wide font-semibold px-2 py-0.5 rounded flex items-center gap-1">
            <Play size={10} className="fill-white" /> Video
          </span>
        )}
      </Link>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-2">
          <Link
            to={`/categoria/${article.categorySlug}`}
            className="text-[11px] uppercase tracking-wide text-sq-orange font-semibold"
          >
            {article.category}
          </Link>
          <span className="text-xs text-gray-400 flex items-center gap-1">
            <Clock size={12} /> {article.readTime}
          </span>
        </div>
        <Link to={`/articolo/${article.slug}`}>
          <h3 className="font-serif-display text-xl leading-snug text-sq-navy article-title-hover">
            {article.title}
          </h3>
        </Link>
        <p className="text-sm text-gray-600 mt-2 leading-relaxed line-clamp-3">{article.excerpt}</p>
        <div className="flex items-center justify-between mt-4 pt-3 border-t border-sq">
          <span className="text-xs text-gray-500">{article.author}</span>
          <span className="text-xs text-gray-400">{article.date}</span>
        </div>
      </div>
    </article>
  );
};

export default ArticleCard;
